export default "__VITE_ASSET__pCXDIpwi__"